import { Observable, of } from 'rxjs'
import { catchError, filter, switchMap, take, timeout } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { SerieProposal } from '../serie-proposal'
import { serieProposalActions } from '../serie-proposal.actions'
import { serieProposalSelectors } from '../serie-proposal.selectors'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'

@Component({
  selector: 'serie-proposal-general-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SerieProposalGeneralTabComponent implements OnInit {
  @Input() serieProposalId: number
  @Input() isModal: boolean = false
  @Input() fromInitialRequest: boolean = false
  @Output() onCloseModal = new EventEmitter<any>()
  public serieProposal$: Observable<SerieProposal>
  public serieProposalId$: Observable<number>
  public form: UntypedFormGroup

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.serieProposalId$ = this.serieProposalId
      ? of(this.serieProposalId)
      : this.store
          .select(serieProposalSelectors.selectIdRouteParam)
          .pipe(filter((id) => Boolean(id)))

    this.serieProposal$ = this.serieProposalId$.pipe(
      switchMap((serieProposalId) =>
        this.store.select(serieProposalSelectors.selectById, serieProposalId)
      )
    )
  }

  public onSubmit(form): void {
    // mark
    this.serieProposalId$.pipe(take(1)).subscribe((serieProposalId) =>
      this.store.dispatch(
        serieProposalActions.updateOneById({
          id: serieProposalId,
          params: {
            ...form,
            id: parseInt(serieProposalId.toString())
          }
        })
      )
    )
    this.actions$
      .pipe(
        ofType(serieProposalActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  public closeModal() {
    if (this.isModal) {
      this.onCloseModal.emit()
    }
  }
}
